import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'I RISULTATI DELLA TUA RICERCA',
        description:
            "Gli esercizi sono presentati dal più recente in poi. Per ognuno vedi le informazioni base e il tipo. Vedi anche l'incipit dell'esercizio e gli argomenti su cui verte.",
        isActive: true,
        name: 'SpecialExercisesSearchPanel',
        tutorialName: 'crea-verifica_risultati-speciali-Zanichelli'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: 35,
        yOffset: -710
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: 20,
        yOffset: -1055
    }
};
